import { Text, View } from "@react-pdf/renderer";
import ContractStyles from "../styles/contractStyles";

const PageFooter = ({
  startPage = 3,
  agreementTitle = "Contract for Services",
}) => {
  const styles = ContractStyles();

  return (
    <View
      fixed
      style={[
        styles.flexRow,
        styles.spaceBetween,
        styles.px_xxl,
        {
          position: "absolute",
          bottom: 32,
          left: 0,
          width: "100%",
        },
      ]}
    >
      <View style={[styles.flexColumn, styles.gap_xxs]}>
        <Text
          fixed
          render={({ pageNumber }) =>
            pageNumber >= startPage
              ? `Rosemount Financial Solutions (IFA) Ltd - ${agreementTitle}`
              : null
          }
          style={[styles.buttonTextSmall, styles.text_gray_70]}
        />
        <Text
          fixed
          render={({ pageNumber }) =>
            pageNumber >= startPage
              ? "Initialled by Appointed Representative: __________"
              : null
          }
          style={[styles.buttonTextSmall, styles.text_gray_70]}
        />
        <Text
          fixed
          render={({ pageNumber }) =>
            pageNumber >= startPage ? "Initialled by Rosemount: __________" : null
          }
          style={[styles.buttonTextSmall, styles.text_gray_70]}
        />
      </View>
      <Text
        fixed
        render={({ pageNumber }) =>
          pageNumber >= startPage ? `${pageNumber}` : null
        }
        style={[styles.buttonTextSmall, styles.text_gray_70]}
      />
    </View>
  );
};

export default PageFooter;
